import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getContentItemIconFromType } from 'utils/icons';
import getContentItemType from 'utils/asset/getContentItemType';
import Button from 'components/Button';
import Box from 'components/Box';
import Card from 'components/Card';
import Stack from 'components/Stack';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import Meter from 'components/Meter';
import Icon from 'components/Icon';
import { TinyHorizontalCard } from 'components/ContentCards';
import InlineList from 'components/InlineList';
import getPictureUrl from 'utils/image/getPictureUrl';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var UploadProgressModal = function UploadProgressModal(_ref) {
  var isInProgress = _ref.isInProgress,
    isProcessing = _ref.isProcessing,
    uploadProgress = _ref.uploadProgress,
    asset = _ref.asset,
    onCancel = _ref.onCancel,
    onClose = _ref.onClose,
    onEdit = _ref.onEdit;
  var name = asset.name,
    thumbnailId = asset.thumbnailId,
    assetContentType = asset.assetContentType,
    customType = asset.customType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = 'playlist-editor-dialog-title';
  var modalTitle = isInProgress ? t("content_uploading_".concat(assetContentType)) : t('content_upload_complete');
  var rawType = getContentItemType({
    customType: customType,
    type: assetContentType
  });
  var icon = getContentItemIconFromType(rawType);
  var progress = uploadProgress ? "".concat(t('form_uploaded_progress', {
    progress: "".concat(Math.ceil(uploadProgress), "%")
  })) : undefined;
  var buttonProps = {
    icon: 'edit',
    label: t('actions_click_to_edit'),
    onClick: onEdit
  };
  var meterId = 'upload-progress-meter';
  return /*#__PURE__*/_jsx(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: !isInProgress ? onClose : function () {
      return undefined;
    },
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        title: modalTitle,
        titleId: titleId,
        onClose: !isInProgress ? onClose : undefined,
        size: "large"
      }), /*#__PURE__*/_jsx(Panel, {
        children: isInProgress ? t('content_uploading_file_info') : isProcessing ? /*#__PURE__*/_jsxs(Stack, {
          spacing: "s",
          children: [t('content_upload_successful'), t('content_processing_file_info')]
        }) : t('content_upload_successful_and_ready')
      }), /*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsxs(Stack, {
          spacing: "s",
          children: [/*#__PURE__*/_jsx(TinyHorizontalCard, {
            isImageLeft: true,
            title: name,
            subtitle: /*#__PURE__*/_jsxs(InlineList, {
              as: "span",
              itemAs: "span",
              splitBy: "dot",
              display: "inline",
              children: [/*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(Icon, {
                  vAlign: true,
                  dimmed: true,
                  name: icon,
                  mr: "xxs"
                }), t("file_type_".concat(assetContentType))]
              }), isInProgress && t('actions_click_to_edit')]
            }),
            imageSource: getPictureUrl({
              id: thumbnailId
            }),
            icon: icon,
            buttonProps: isInProgress ? buttonProps : undefined
          }), /*#__PURE__*/_jsx(Meter, {
            value: uploadProgress ? uploadProgress / 100 : undefined,
            color: "positive",
            id: meterId
          }), /*#__PURE__*/_jsx(Box, {
            textAlign: "center",
            children: /*#__PURE__*/_jsx("label", {
              htmlFor: meterId,
              children: progress
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: isInProgress ? /*#__PURE__*/_jsx(Button, {
          variant: "transparent",
          onClick: onCancel,
          children: t('actions_cancel_upload')
        }) : /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onClose,
          children: t('actions_view_in_playlist')
        })
      })]
    })
  });
};
export default UploadProgressModal;